<form [formGroup]="permissionForm">
    <mat-form-field>
        <mat-select
            placeholder="{{ 'Login.Role' | translate }}"
            [formControl]="permissionForm.controls['roleId'] | formControl"
            (selectionChange)="onRoleChange($event)">
            @for (role of roles; track role.id) {
                <mat-option [value]="role.id" [id]="role.id">
                    {{ role.name }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <br />
    @if (!isLoading()) {
        <div formArrayName="permissions">
            <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor">
                <mat-tree-node *matTreeNodeDef="let node" class="tree-node">
                    <button mat-icon-button disabled></button>
                    <mat-checkbox [formControlName]="getFormControlName(node)">
                        {{ node.description }}
                    </mat-checkbox>
                </mat-tree-node>
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" class="tree-node">
                    <div class="tree-node">
                        <button mat-icon-button matTreeNodeToggle>
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>
                        {{ node.name }}
                    </div>
                    <div [class.tree-invisible]="!tree.isExpanded(node)">
                        <ng-container matTreeNodeOutlet />
                    </div>
                </mat-nested-tree-node>
            </mat-tree>
        </div>
    } @else {
        <mat-progress-bar mode="indeterminate" />
    }
</form>
